var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusBehind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44226 1.69659C9.34635 1.50939 9.20064 1.35228 9.02118 1.24258C8.84171 1.13288 8.63545 1.07483 8.42511 1.07483C8.21477 1.07483 8.00852 1.13288 7.82905 1.24258C7.64959 1.35228 7.50388 1.50939 7.40797 1.69659L1.12226 14.268C1.03459 14.442 0.992848 14.6355 1.001 14.8301C1.00916 15.0248 1.06693 15.2141 1.16884 15.3802C1.27075 15.5462 1.41342 15.6834 1.58328 15.7788C1.75315 15.8742 1.94458 15.9246 2.1394 15.9252H14.7108C14.9056 15.9246 15.0971 15.8742 15.2669 15.7788C15.4368 15.6834 15.5795 15.5462 15.6814 15.3802C15.7833 15.2141 15.8411 15.0248 15.8492 14.8301C15.8574 14.6355 15.8156 14.442 15.728 14.268L9.44226 1.69659Z",
    stroke: "#EB8F5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42517 6.21088V9.92516",
    stroke: "#EB8F5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42512 13.068C8.34934 13.068 8.27667 13.0379 8.22309 12.9843C8.16951 12.9307 8.1394 12.8581 8.1394 12.7823C8.1394 12.7065 8.16951 12.6338 8.22309 12.5803C8.27667 12.5267 8.34934 12.4966 8.42512 12.4966",
    stroke: "#EB8F5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42517 13.068C8.50095 13.068 8.57362 13.0379 8.6272 12.9843C8.68078 12.9307 8.71089 12.8581 8.71089 12.7823C8.71089 12.7065 8.68078 12.6338 8.6272 12.5803C8.57362 12.5267 8.50095 12.4966 8.42517 12.4966",
    stroke: "#EB8F5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusBehind);
export default __webpack_public_path__ + "static/media/status-behind.d3e7bd505947b0d563807092a62cb8c4.svg";
export { ForwardRef as ReactComponent };